import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faCog,
  faFlag,
  faHome,
  faHeart,
  faHandPaper,
  faHourglassStart,
  faMapMarkerAlt,
  faPaperPlane,
  faQuestion,
  faTimes,
  faTree,
  faUser,
  faUsers,
  faSpinner,
  faGamepad,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { store } from "./stores";

library.add(
  faArrowLeft,
  faArrowRight,
  faBars,
  faCog,
  faHome,
  faHeart,
  faFlag,
  faHandPaper,
  faHourglassStart,
  faMapMarkerAlt,
  faPaperPlane,
  faQuestion,
  faTimes,
  faTree,
  faUser,
  faUsers,
  faSpinner,
  faGamepad,
);

const app = createApp(App);
app.component("fa-icon", FontAwesomeIcon);
app.use(store);
app.use(router);
app.mount("#app");
